import React from 'react';

const ColorPagesSection = ({ submission, jsonContent, isDark }) => {
    return (
        <div className={`rounded-[10px] shadow-[0px_4px_4px_0px_rgba(0,0,0,0.11)] p-[20px] flex flex-col gap-[12px] transition-colors duration-200 ${
            isDark ? 'bg-[#000000]' : 'bg-white'
        }`}>
            <p className={`m-0 text-[16px] font-semibold transition-colors duration-200 ${
                isDark ? 'text-white' : 'text-[#072837]'
            }`}>Mark all pages to be colored?</p>
            <div>
                <input 
                    className={`w-full px-[16px] py-[12px] rounded-[8px] border-none text-[16px] transition-colors duration-200 focus:outline-none focus:ring-0 focus:border-transparent ${
                        isDark 
                            ? 'bg-[#161515]  text-white' 
                            : 'bg-[#f5f5f5] text-[#072837]'
                    }`}
                    type="text" 
                    value={ submission.colorPages == 'true' || jsonContent.colorPages == 'true' ? 'Yes' : submission.colorPages == 'false' || jsonContent.colorPages == 'false' ? 'No' : '' } 
                    readOnly 
                />
            </div>
        </div>
    );
};

export default ColorPagesSection;
